import { useTheme } from 'styled-components';
import Row from '@sdk/components/ui/spacing/Row';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import gettext from '@sdk/lang/gettext';
import Text16 from '@sdk/components/ui/typography/Text16';
import H2 from '@sdk/components/ui/typography/H2';
import EmployeeSvg from '@sdk/assets/svg/Icons/32/groups-gray.svg';
import SignupRouteTile from '@sdk/login/components/SignupRouteTile';
import StyledSvg from '@sdk/components/ui/StyledSvg';
import { useOneClickToastConnect } from '@sdk/integrations/hooks/useOneClickToastConnect';
import { useFeatureFlag } from '@sdk/featureFlags/useFeatureFlag';
import { FeatureFlag } from '@sdk/featureFlags/types';

import ToastImg from '../../../assets/svg/Icons/32/toast.svg';

type Props = {
  onManualSetup: () => void;
  onToastConnect: () => void;
};

export const ToastAssistStep = ({ onManualSetup, onToastConnect }: Props) => {
  const theme = useTheme();
  const { connectToast } = useOneClickToastConnect();
  const isOneClickEnabled = useFeatureFlag(FeatureFlag.TOAST_ONE_CLICK_INTEGRATION_SETUP_ENABLED);

  return (
    <>
      <Row>
        <H2 themeColor={ThemeColorType.primaryText}>{gettext('Welcome to Sling!')}</H2>
      </Row>
      <Row top={10}>
        <Text16 themeColor={ThemeColorType.gray}>{gettext('How would you like to start?')}</Text16>
      </Row>
      <Row top={20}>
        <SignupRouteTile
          icon={<ToastImg />}
          mainText={gettext('Connect Sling and Toast')}
          descriptionText={gettext('Set up Sling account using data from Toast')}
          onClick={isOneClickEnabled ? connectToast : onToastConnect}
        />
      </Row>
      <Row top={20}>
        <SignupRouteTile
          icon={<StyledSvg svg={EmployeeSvg} color={theme.colors.primary} />}
          mainText={gettext('Set up my Sling account')}
          descriptionText={gettext('Set up Sling account from scratch manually')}
          onClick={onManualSetup}
        />
      </Row>
    </>
  );
};
